export default "__VITE_ASSET__j2En7aFa__"